module.exports = __webpack_public_path__ + "img/slider1.828db7fa.gif";